import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { Address } from '../model/address.model';
import { List } from '../model/list.model';
import { Page } from '../model/page.model';
import { Data } from '../model/data.model';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  constructor(private http: HttpClient) { }

  getUserAddressList(page: Page): Observable<Data<List<Address>>> {
    return this.http.post<Data<List<Address>>>(`${environment.apiURL}/Address/addressList`, page).pipe(
      catchError(this.handleError)
    )
  }

  setDefaultAddress(obj: any): Observable<Data<any>> {
    return this.http.put<Data<any>>(`${environment.apiURL}/Address/setDefaultAddress`, obj).pipe(
      catchError(this.handleError)
    )
  }

  deleteAddress(obj: any): Observable<Data<any>> {
    return this.http.delete<Data<any>>(`${environment.apiURL}/Address/deleteAddress`, { body: obj }).pipe(
      catchError(this.handleError)
    )
  }

  addAddress(address: Address): Observable<Data<any>> {
    return this.http.post<Data<any>>(`${environment.apiURL}/Address/addAddress`, address).pipe(
      catchError(this.handleError)
    )
  }

  updateAddress(address: Address): Observable<Data<any>> {
    return this.http.put<Data<any>>(`${environment.apiURL}/Address/updateAddress`, address).pipe(
      catchError(this.handleError)
    )
  }

  private handleError(err: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    }
    else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;

    }
    return throwError(() => errorMessage);
  }
}
